/*
 * Favoritos del cliente, guardados en su propio navegador.
 * El corazón de cada ficha usa la MISMA lista que la página de Favoritos
 * y que el corazón de la cabecera: se guardan los «handle» de las piezas
 * en 'barcon-favoritos'.
 * Toggles the heart on product cards and remembers favorites in localStorage
 * (per device/browser). Uses event delegation so it also covers cards that are
 * injected later (quick-add, AJAX collection loading, etc.).
 */
(function () {
  var KEY = 'barcon-favoritos';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode) — fail silently */
    }
  }

  function setState(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active
      ? btn.getAttribute('data-label-on') || 'Quitar de favoritos'
      : btn.getAttribute('data-label-off') || 'Añadir a favoritos';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }

  function refresh(scope) {
    var saved = read();
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      setState(btn, saved.indexOf(String(btn.getAttribute('data-product-handle'))) !== -1);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;

    // Don't let the click bubble to the card's link / quick-add.
    event.preventDefault();
    event.stopPropagation();

    var id = String(btn.getAttribute('data-product-handle'));
    var list = read();
    var idx = list.indexOf(id);
    var active;

    if (idx === -1) {
      list.push(id);
      active = true;
    } else {
      list.splice(idx, 1);
      active = false;
    }
    write(list);

    // Sync every button on the page that points to the same product.
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle="' + id + '"]').forEach(function (b) {
      setState(b, active);
    });

    // El corazón de la cabecera y la página de Favoritos se enteran.
    document.dispatchEvent(new CustomEvent('barcon:favoritos'));

    // Avisito abajo a la izquierda, con la foto de la pieza.
    if (window.BarconAviso) {
      var tarjeta = btn.closest('.card-wrapper, .card, li');
      var foto = tarjeta ? tarjeta.querySelector('img') : null;
      window.BarconAviso(
        active ? 'Guardada en favoritos' : 'Quitada de favoritos',
        foto ? foto.currentSrc || foto.src : null,
        active
      );
    }
  });

  // Si se guarda desde la ficha de la pieza o desde otra pestaña.
  document.addEventListener('barcon:favoritos', function () { refresh(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });

  function init() {
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Allow other scripts to re-sync after injecting cards dynamically.
  window.BarconWishlist = { refresh: refresh };
})();
